import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { CONSTANTS } from '../common/constants';
// Set up default config for http requests here
// Please have a look at here `https://github.com/axios/axios#request- config` for the full list of configs
const axiosSecretInstance = axios.create({
    baseURL: CONSTANTS.BASE_API
    // paramsSerializer: (params) => queryString.stringify(params),
});

axiosSecretInstance.interceptors.request.use(async (config) => {
    const token = localStorage.getItem(CONSTANTS.LOGIN_TOKEN);
    const language = localStorage.getItem(CONSTANTS.LANGUAGE) || 'VI';

    if (token) {
        config.headers = {
            Authorization: `Bearer ${token}`,
            language
        };
    }
    return config;
});

axiosSecretInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        let history = useHistory();
        // eslint-disable-next-line no-console
        if (error.response && error.response.status === 401) {
            // actionRefreshToken();
            // Xử lí refreshtoken tại đây nếu bị lỗi 401
            localStorage.removeItem(CONSTANTS.LOGIN_TOKEN);
            history.push('/dang-nhap');
        } else {
            return Promise.reject(error);
        }
    },
);

export default axiosSecretInstance;